import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import Api from '../../../utils/api';
import Toaster from '../../Toaster/Index';
import { LeftPanel } from '../../Wrappers';
import { sendAmplitudeEvents, updatePluginList } from '../../../utils/helper';
import { EventNames } from '../../../utils/events';
import { LTBox, LTButton, LTCheckbox, LTFormControl, LTLoader, LTPagination, LTSelect, LTText } from '@lambdatestincprivate/lt-components';
import { Link, Token } from '@primer/react';
import { setZohoProjectOptions } from '../../../redux/features/configSlice';
import { DataTable, Table } from '@primer/react/drafts';
import LTTextInput from '@lambdatestincprivate/lt-components/lib/components/LTInputBox';




const docLink = `${process.env.REACT_APP_DOC_URL}/zohoproject-integration`;

const locations = {
    "United States (us)": "com",
    "Europe (eu)": "eu",
    "India (in)": "in",
    "United Kingdom (uk)": "uk",
    "Japan (jp)": "jp",
    "Australia (au)": "com.au",
    "Canada (ca)       ": "cloud.ca",
    "Saudi Arabia (sa) ": "sa",
    "United Arab Emirates (uae)": "ae",
}

interface IProject {
    id: string;
    name: string;
    is_bug_enabled: boolean;
}

const perPageProjects = 50


export default function ZohoProject() {
    const dispatch = useDispatch();
    const sideBarObject: any = useSelector(
        (state: RootState) => state.config.sideBarObject
    );
    const zohoProjectOptions = useSelector(
        (state: RootState) => state.config.zohoProjectOptions
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isgettingData,setIsGettingData] = useState(false);
    const [location, setLocation] = useState('');
    const [errors, setErrors] = useState({});
    const [portal,setPortal] = useState('');
    const [portalName,setPortalName] = useState('');
    const [totalProjects, setTotalProjects] = useState(0);
    const [projectsList, setProjectsList] = useState<IProject[]>([]);
    const [filteredProjectList, setFilteredProjectList] = useState<IProject[]>([]);
    const [tempProjectList, setTempProjectList] = useState<IProject[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<IProject[]>([]);
    const [searchedCount, setSearchedCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastSearched, setLastSearched] = useState('');
    const [search, setSearch] = useState('');
    const reAuthorize:boolean = sideBarObject?.is_installed && sideBarObject?.token_expired;
    const shouldResync:boolean = (sideBarObject?.should_resync!=null && sideBarObject?.should_resync == true)
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [selectAllIndeterminate, setSelectAllIndeterminate] = useState(false);


    
    useEffect(() => {
        if (shouldResync){
            getProjects();
        }
    }, [shouldResync]);

    useEffect(() => {
        if (tempProjectList.length === 0) {
            setSelectAllChecked(false);
            setSelectAllIndeterminate(false);
            return;
        }
        const selectedCount = tempProjectList.filter(project => selectedProjects.some(sel => sel.id === project.id)).length;
        if (selectedCount === tempProjectList.length) {
            setSelectAllChecked(true);
            setSelectAllIndeterminate(false);
        } else if (selectedCount === 0) {
            setSelectAllChecked(false);
            setSelectAllIndeterminate(false);
        } else {
            setSelectAllChecked(false);
            setSelectAllIndeterminate(true);
        }
    }, [tempProjectList, selectedProjects]);

    const handleSelectAll = (checked: boolean) => {
        if (checked) {
            const newSelected = [...selectedProjects];
            tempProjectList.forEach(project => {
                if (!newSelected.some(sel => sel.id === project.id)) {
                    newSelected.push(project);
                }
            });
            setSelectedProjects(newSelected);
        } else {
            setSelectedProjects(selectedProjects.filter(sel => !tempProjectList.some(project => project.id === sel.id)));
        }
        setSelectAllChecked(checked);
    };

    const install = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        sendAmplitudeEvents(EventNames.INT_CLICK_INSTALL, {
            category: sideBarObject.category,
            plugin_name: sideBarObject.name,
        });
        try {
            var payload: any = {
                "START_OAUTH":true,
                "HOST": location,
            };
            if (reAuthorize){
                payload = {
                    "REAUTHORIZE":true,
                }
            }
            const res = await Api.installApi.apiInstall(sideBarObject.code, payload);
            setIsLoading(false);
            if (res.data.url) {
                window.open(res.data.url,  '_self');
                return;
            }
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    };

  
    const portalInstall = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        if(portal) {
            getProjects();
        }
    }

    const getProjects = async() => {
        try {
            setIsLoading(true);
            setIsGettingData(true);
            const res = await Api.installApi.apiInstall(sideBarObject.code, {
                "PORTAL_ID": portal,
                "GET_PROJECTS": true,
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            if (res.data.projects && res.data.projects.length > 0) {
                setProjectsList(res.data.projects);
                setFilteredProjectList(res.data.projects);
                const totalProjects = res.data.projects.length;
                setTotalProjects(totalProjects);
                setSearchedCount(totalProjects);
                setTempProjectList(totalProjects > perPageProjects ? res.data.projects.slice(0, perPageProjects) : res.data.projects);
                setCurrentPage(1);
            }
            setIsLoading(false);
            setIsGettingData(false);
            dispatch(setZohoProjectOptions({ zohoProjectOptions: null }));

        } catch (err: any) {
            if (err.response.data.message) {
                Toaster.error(err.response.data.message);
            } else {
                Toaster.error('Something went wrong');
            }
            setIsLoading(false);
            setIsGettingData(false);
            dispatch(setZohoProjectOptions({ zohoProjectOptions: null }));
        }
    }

    const checkProject = (checked: boolean, element: IProject) => {
        if (checked === false) {
            setSelectedProjects(
                selectedProjects.filter((elem) => elem.id !== element.id)
            );
        } else {
            setSelectedProjects([...selectedProjects, element]);
        }
    };

    const projectInstall = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        if (selectedProjects.length < 1) {
            return;
        }
        try {
            setIsLoading(true);
            const res = await Api.installApi.apiInstall(sideBarObject.code, {
                "SELECTED_PROJECTS": selectedProjects,
                "PORTAL_ID": portal,
                "START_INSTALL": true,
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            setIsLoading(false);
            await updatePluginList();
        } catch (err: any) {
            if (err.response?.data?.message) {
                Toaster.error(err.response.data.message);
            }
            setIsLoading(false);
        }
    };


    const paginate = async (page: number) => {
        const newCurrentPage = page;
        setCurrentPage(newCurrentPage);
        const startIndex = (newCurrentPage - 1) * perPageProjects;
        const endIndex = Math.min(startIndex + perPageProjects, filteredProjectList.length);
        const tempProjects = filteredProjectList.slice(startIndex, endIndex);
        setTempProjectList(tempProjects);
    };


    const searchProject = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        if (search.length === 0) {
            return;
        }
        
        const filteredProjects = projectsList.filter(
            (project) => project.name.toLowerCase().includes(search.toLowerCase())
        );
        
        setFilteredProjectList(filteredProjects);
        const filteredProjectsLength = filteredProjects.length
        setSearchedCount(filteredProjectsLength);
        setTempProjectList(filteredProjectsLength > perPageProjects ? filteredProjects.slice(0, perPageProjects): filteredProjects);
        setCurrentPage(1);
        setLastSearched(search);
        return;
    };

    const searchClear = async () => {
        setSearch('')
        setFilteredProjectList(projectsList);
        setTempProjectList(totalProjects > perPageProjects ? projectsList.slice(0, perPageProjects) : projectsList);
        setSearchedCount(totalProjects)
        setCurrentPage(1);
    };

    
    return (
        <LeftPanel>
        {
        (isgettingData)?
        <div className='flex flex-col items-center justify-center h-full space-y-4 mb-4'>
            <LTLoader
                heading={`Getting data ...`}
                size='large'
                containerStyles={{ height: 'auto' }}
            />
        </div>
        :
        (zohoProjectOptions!=null && zohoProjectOptions.length > 0 && totalProjects === 0)? (
        <LTFormControl
            formStyles={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
            label='Select your Portal'
            labelStyle={{
                fontSize: 12,
            }}
        >
            <LTSelect
                options={zohoProjectOptions.map((elem) => ({
                    name: elem.name,
                    value: elem.id,
                }))}
                onChange={(values :any) => {
                    setPortal(values[0].value);
                    setPortalName(values[0].name);
                }}
                customButtonText={portalName!=""?portalName:'Select Portal'}
                buttonStyle={{
                    width: '100%',
                    maxWidth: '100%',
                    '[data-component="buttonContent"]': {
                        justifyContent: 'start',
                    },
                }}
                leadingText=""
            />
            <LTBox>
                <LTButton
                    onClick={portalInstall}
                    disabled={isLoading}
                    variant={LTButton.Variant.PRIMARY}
                >
                    Select Portal & Proceed
                </LTButton>
            </LTBox>
        </LTFormControl>
        ):(totalProjects > 0) ? (
            <div>
                <LTText
                    as='h6'
                    fontSize={14}
                    text='Select Projects'
                />
                <div className='flex justify-between space-x-2 mb-2'>
                    <form
                        id='form2'
                        onSubmit={searchProject}
                        className='w-full'
                    >
                        <LTTextInput
                            type='text'
                            contrast
                            aria-label='Search Project'
                            onChange={(value :any) => setSearch(value)}
                            value={search}
                            placeholder='Press Enter to Search'
                            // leadingVisual={<SearchIcon />}
                            width={'100%'}
                            allowClearSearch={false}
                        />
                    </form>
                    {lastSearched.length > 0 && (
                        <LTButton onClick={searchClear} variant={LTButton.Variant.DEFAULT}>
                            Clear
                        </LTButton>
                    )}
                </div>
                {selectedProjects.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', marginBottom: 8 }}>
                        {selectedProjects.map((project) => (
                            <Token
                                key={project.id}
                                text={project.name}
                                sx={{
                                    mb: '6px',
                                    mr: '8px',
                                    fontWeight: 600,
                                    color: 'token.fg',
                                    bg: 'token.bg',
                                    borderColor: 'border.muted',
                                    padding: '0px 0px 0px 8px',
                                }}
                                onRemove={() =>
                                    checkProject(false, project)
                                }
                                size='small'
                            ></Token>
                        ))}
                    </div>
                )}
                <LTBox styles={{ overflowY: 'scroll' }}>
                    <Table.Container>
                        <DataTable
                            aria-labelledby='projects'
                            aria-describedby='projects'
                            data={tempProjectList}
                            columns={[
                                {
                                    id: 'select_name',
                                    header: () => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <LTCheckbox
                                                checked={selectAllChecked}
                                                indeterminate={selectAllIndeterminate}
                                                onChange={handleSelectAll}
                                                label={''}
                                                labelStyle={{ fontWeight: 600 }}
                                            />
                                            <span style={{ marginLeft: 8 }}>{`${selectedProjects.length} projects selected`}</span>
                                        </div>
                                    ),
                                    renderCell: (row) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <LTCheckbox
                                                checked={selectedProjects.some((p) => p.id === row.id)}
                                                onChange={(value: any) => {
                                                    checkProject(value, row)
                                                }}
                                                label={''}
                                            />
                                            <span style={{ fontWeight: 600, marginLeft: 8 }}>{row.name}</span>
                                        </div>
                                    ),
                                },
                            ]}
                        ></DataTable>
                    </Table.Container>
                </LTBox>
                <LTBox
                        padding={'8px 0px'}
                        className='paginationContainer'
                        styles={{
                            border: '1px',
                            borderStyle: 'solid',
                            borderColor: 'border.default',
                        }}
                    >
                        <LTPagination
                            pageCount={Math.ceil(searchedCount / perPageProjects)}
                            currentPage={currentPage}
                            surroundingPageCount={1}
                            onChange={(e: React.ChangeEvent<any>) => {
                                const hash =
                                    e.currentTarget.getAttribute('href') ||
                                    '';
                                if (hash.length > 0) {
                                    const pageIndex = parseInt(
                                        hash.substring(1)
                                    );
                                    paginate(pageIndex);
                                }
                            }}
                        />
                    </LTBox>
                <LTBox className='mt-4'>
                    <LTButton
                        onClick={projectInstall}
                        disabled={isLoading || selectedProjects.length < 1}
                        variant={LTButton.Variant.PRIMARY}
                    >
                        Integrate Projects & Install
                    </LTButton>
                </LTBox>
            </div>
            ) 
            : 
            (
            (reAuthorize)? (
                <LTButton
                    variant={LTButton.Variant.PRIMARY}
                    disabled={isLoading}
                    onClick={install}
                    className='self-start'
                >
                Re-Authorize
                </LTButton>
                ):
            <>
            <form
                action=''
                className='flex flex-col space-y-4'
                id='form1'
                onSubmit={install}
            >
                               <LTFormControl
                    label='Select your Zoho Project Region'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTSelect
                        options={Object.entries(locations).map(([key, value]) => ({
                            name: key,
                            value: value,
                        }))}
                        onChange={(values: any) => {
                            setLocation(values[0].value);
                        }}
                        customButtonText={location ? locations[location as keyof typeof locations] : 'Select Zoho Region'}
                        buttonStyle={{
                            width: '100%',
                            maxWidth: '100%',
                            '[data-component="buttonContent"]': {
                                justifyContent: 'start',
                            },
                        }}
                        leadingText=""
                    />
                </LTFormControl>   

                <LTButton
                    variant={LTButton.Variant.PRIMARY}
                    disabled={isLoading}
                    onClick={install}
                    className='self-start'
                >
                    Install
                </LTButton>
            </form>
            <div className='grid inline-block min-[686px]:absolute min-[686px]:bottom-0 max-[685px]:mt-[16px] mb-[16px]'>
                <LTText color={"muted"}
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "16px",
                    color: '#666666'
                  }}>Know how to integrate ZohoProject</LTText>
                <Link
					className='focus-black'
                    href={docLink}
                    target='_blank'
                    rel='noreferrer'
                >
                    ZohoProject Integration Guide
                </Link>
            </div>
            </>
            )}

        </LeftPanel>
    );
}
